<template>
  <div class="router-error-404-catchall">
    <titleBar
      :title="'Discord'"
      back="auto"
      :showBackArrowDesktop="true"
      subtitle=""
      :centered="false"
      theme="white"
      :showSignup="false"
      containerClass="donotuse"
      :showDesktop="true"
      :showAfterScroll="0"
      :scrollTopOnClick="true"
      :inline="false"
      actionButtonStyle="round"
      actionButtonRoundBg="transparent"
      iconPack="fas"
    />

    <div class="section">
      <div class="container text-align-center">
        <h1 class="center title is-1"><span class="rad-color">Woo-Hah!</span></h1>
        <br />

        <h2 class="txt-center subtitle is-4">A welcome email is flying your way.</h2>

        <h3 class="txt-center">While you wait, come and join our Discord community and introduce yourself:</h3>
        <br />
        <a
          class="button is-dark is-large"
          href="https://discord.gg/kYKdsTvheA"
          style="margin: auto; display: inline-block"
          >Join Discord</a
        >
      </div>
    </div>
    <!-- 
    <empty title="Join Discord" hrefTo="https://discord.gg/kYKdsTvheA" btLabel="View Discord Server" />
   -->
    <!--
      <h1>This is an 404 page - not found...</h1>
  
  
          <h1>This is an 404 page - not found...</h1>
              <h1>This is an 404 page - not found...</h1>
                  <h1>This is an 404 page - not found...</h1>
                      <h1>This is an 404 page - not found...</h1>
  
                    -->
  </div>
</template>
<script>
import e404 from "@/components/e/e404";

export default {
  data() {
    return {
      transitionName: "fade", //default
    };
  },
  components: {
    //   e404,
    //  Footer: Footer
  },
};
</script>
